var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProductPinBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    className: "icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3884C5",
    fillRule: "evenodd",
    d: "M15.634 13.917c0-2.586 2.052-4.682 4.584-4.682 2.532 0 4.584 2.096 4.584 4.682 0 2.587-2.052 4.683-4.584 4.683-2.532 0-4.584-2.096-4.584-4.683zm-7.14-5.94c-.584 1.183-.99 2.452-1.258 3.747C4.946 22.812 20.081 38.68 20.081 38.68c2.523-2.935 4.792-6.147 6.84-9.44 3.898-6.262 7.893-13.982 4.333-21.377-4.5-9.347-18.264-8.989-22.76.113z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductPinBlue);
export default __webpack_public_path__ + "static/media/icon-product-pin-blue.c39aa23f5290e6b50947f88cc54f3f1d.svg";
export { ForwardRef as ReactComponent };